/**
 * style props are based on the utils defined in the stitches config
 * File: src/_common/stitches/config/utils.ts
 * */
const ENABLED_STYLE_PROPS = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py'];
export { ENABLED_STYLE_PROPS };